module.exports = __webpack_public_path__ + "img/powerpoint.6ce53ef0.svg";